module.exports = __webpack_public_path__ + "img/Butterfly_00356.cd3cf24c.png";